import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import AnalysesOverview from "./pages/AnalysesOverview";
import AdminInterface from "./pages/AdminInterface";
import AnalysisDetail from "./pages/AnalysisDetail";
import TosAnalyzerPage from "./pages/TosAnalyzerPage";
import ProfilePage from "./pages/ProfilePage";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />

      {/* Main layout wrapper */}
      <div className="min-h-screen flex flex-col bg-gray-50 container">
        {/* Navbar with full width background */}
        <Navbar />

        {/* Main content area */}
        <main className="flex-1 bg-nn-gray-50">
          {/* Container for route content - standardized padding and max-width */}
          <div className="mx-auto max-w-7xl w-full">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<AnalysesOverview />} />
              <Route
                path="/scan"
                element={
                  <PrivateRoute>
                    <TosAnalyzerPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute requiredRole="admin">
                    <AdminInterface />
                  </PrivateRoute>
                }
              />
              <Route path="/analyses/:id" element={<AnalysisDetail />} />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </main>

        {/* Footer with full width background */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
